<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { authState, logout } from '../utils/auth';

const open = ref(false);
const root = ref<HTMLElement>();
const user = computed(() => authState.user);
const initial = computed(() => (user.value?.email || user.value?.username || '?').charAt(0).toUpperCase());

const onClickOutside = (event: MouseEvent) => {
  if (root.value && !root.value.contains(event.target as Node)) open.value = false;
};
const onKey = (event: KeyboardEvent) => {
  if (event.key === 'Escape') open.value = false;
};
onMounted(() => {
  document.addEventListener('click', onClickOutside);
  document.addEventListener('keydown', onKey);
});
onBeforeUnmount(() => {
  document.removeEventListener('click', onClickOutside);
  document.removeEventListener('keydown', onKey);
});
</script>

<template>
  <div ref="root" class="user-menu">
    <button class="fx-avatar" :aria-expanded="open" aria-label="User menu" @click="open = !open">{{ initial }}</button>
    <div v-if="open" class="menu" role="menu">
      <div class="who">
        <strong>{{ user?.email || user?.username }}</strong>
        <div v-if="user?.username && user?.email" class="fx-muted small">{{ user.username }}</div>
        <div v-if="user?.groups.length" class="groups">
          <span v-for="g in user.groups" :key="g" class="fx-badge fx-badge--neutral fx-badge--count">{{ g }}</span>
        </div>
      </div>
      <RouterLink to="/settings" class="item" role="menuitem" @click="open = false">Settings</RouterLink>
      <button class="item danger" role="menuitem" @click="logout">Sign out</button>
    </div>
  </div>
</template>

<style scoped>
.user-menu { position: relative; margin-left: auto; }
.menu {
  position: absolute;
  right: 0;
  top: 44px;
  width: 260px;
  padding: var(--space-3) 0;
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-overlay);
  z-index: 45;
}
.who { padding: var(--space-3) var(--space-5) var(--space-4); border-bottom: 1px solid var(--border); margin-bottom: var(--space-2); word-break: break-all; }
.groups { display: flex; gap: var(--space-2); flex-wrap: wrap; margin-top: var(--space-3); }
.item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: var(--touch-min);
  padding: 0 var(--space-5);
  border: 0;
  background: none;
  color: var(--ink);
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}
.item:hover { background: var(--surface-sunken); }
.danger { color: var(--negative); }
</style>
